module.exports = __webpack_public_path__ + "static/media/MerchDropperLogo.cacc27c9.JPG";